export enum WorkplacePatientStatus {
	ACCEPTED = 'ACCEPTED',
	ACTIVE = 'ACTIVE',
	VIRTUAL = 'VIRTUAL',
	PENDING = 'PENDING',
	HEALTH_PLAN_ACTIVE = 'HEALTH_PLAN_ACTIVE',
	HEALTH_PLAN_CREATED = 'HEALTH_PLAN_CREATED',
	HEALTH_PLAN_NOT_PAID = 'HEALTH_PLAN_NOT_PAID',
	ARCHIVED = 'ARCHIVED',
	ARCHIVED_BY_PATIENT = 'ARCHIVED_BY_PATIENT',
	ARCHIVED_BY_WORKPLACE = 'ARCHIVED_BY_WORKPLACE',
	DECLINED = 'DECLINED'
}
